const uppercaseFilter = ( value: string) => {
  return value.toUpperCase();
};

export default uppercaseFilter;
